import {useRive} from '@rive-app/react-canvas';
import {Store} from 'pullstate';
import {useCallback, useEffect} from "react";
import {AppStore} from "../useAppPullState";

const RiveStore = new Store({
    playing: false,
    animationStopped: true,
    playingTime: 0,
    setLoading: (value) => null,
});



export const usePlay = () => {
    const playingTime = RiveStore.useState(s => s.playingTime);

    return useCallback((value = true) => {
        if(value){
            RiveStore.update((s) => {
                s.playing = true;
                s.animationStopped = false;
                s.playingTime = Date.now();
            });
        }else{
            const now = Date.now();
            const time = now - playingTime;
            const secs = 1000 - (time % 1000)
            setTimeout(() => {
                RiveStore.update((s) => {
                    s.playing = false;
                });
                setTimeout(() => {
                    RiveStore.update((s) => {
                        s.animationStopped = true;
                    });
                }, 750);
            },secs);
        }
    }, [playingTime]);
}

export const createLoading = (handler) => (value) => {
    handler(value)
    RiveStore.update((s) => {
        s.playing = value;
    });
}


export default function RivePreloader() {
    const {rive, RiveComponent} = useRive({
        src: '/golf-preloader-v2-2.riv',
        stateMachines: 'animation-2',
        autoplay: true,
    });

    const {playing,  setLoading, animationStopped} = RiveStore.useState(s => ({
        playing: s.playing,
        setLoading: s.setLoading,
        animationStopped: s.animationStopped
    }));
    const play = usePlay();

    const loading = AppStore.useState(s => s.loading);
    useEffect(() => {

        if (loading && animationStopped) {
            play(true);
        }

        if(!loading && !animationStopped){
            play(false);
        }
    }, [loading, animationStopped])

    useEffect(() => {
        setLoading(playing);
    }, [playing])

    useEffect(() => {
        if (rive?.loaded) {

            const inputs = rive.stateMachineInputs('animation-2');
            const loading = inputs?.find((i) => i.name === 'loading') || null;
            if(loading){
                RiveStore.update((s) => {
                    s.setLoading = createLoading(value => {
                        loading.value = value;
                    });
                });
                loading.value = true;
            }else{
                console.warn('[[rive]] loading input not found')
            }
        }

    }, [rive?.loaded])

    useEffect(() => {
        if(rive?.isStopped){
            RiveStore.update((s) => {
                s.animationStopped = true;
            });
        }
    }, [rive?.isStopped])

    const isHide = !loading && animationStopped;

    return (

        <div style={{
            position: "fixed",
            top: 0,
            left: 0,
            zIndex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100vw",
            height: "100vh",
            backgroundColor: animationStopped ? "transparent" : "white",
            transition: "background-color 0.5s ease-in-out",
            pointerEvents: animationStopped ? "none" : "auto",
        }}>
            <div style={{
                width: "120px",
                height: "120px",
            }}>
                <RiveComponent/>
                <div className={'preloader'}>

                </div>
                <h3 style={{
                    fontFamily: "Inter",
                    position: 'relative',
                    left: '-3px',
                    color: animationStopped ? "transparent" : "#003C7B",
                    transition: "color 0.5s ease-in-out",
                }}>Ladataan...</h3>
                </div>

        </div>

    );
}
